// @ts-nocheck — TODO: tipizzare (S6) — DOM casts
// ====== G3: Heatmap contratti — mesi × densità scadenze contratti ======
// Disegna una matrice 2 righe (anno corrente, anno prossimo) × 12 mesi.
// Ogni cella conta i contratti in scadenza in quel mese, colorato a 5 livelli.
// Click su una cella → vista Scadenze filtrata sul periodo.

function buildHeatmapData(referenceYear) {
  const now = new Date();
  const year = referenceYear || now.getFullYear();
  const rows = [year, year + 1];
  const out = rows.map((y) => ({
    year: y,
    months: Array(12)
      .fill(0)
      .map(() => ({ count: 0, clienti: [] }))
  }));
  // @ts-ignore — state globale
  (state?.clients || []).forEach((c) => {
    const end = c.contratto?.fine;
    if (!end) return;
    const d = new Date(end);
    if (isNaN(+d)) return;
    const idx = rows.indexOf(d.getFullYear());
    if (idx === -1) return;
    const m = d.getMonth();
    out[idx].months[m].count++;
    out[idx].months[m].clienti.push(c.nome);
  });
  return out;
}

function heatmapLevel(n, max) {
  if (!n) return 0;
  if (n === 1) return 1;
  if (n <= max * 0.33) return 2;
  if (n <= max * 0.66) return 3;
  return 4;
}

function renderHeatmap(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;
  const data = buildHeatmapData();
  const allCounts = data.flatMap((r) => r.months.map((m) => m.count));
  const max = Math.max(1, ...allCounts);

  const headMonths = [
    'Gen',
    'Feb',
    'Mar',
    'Apr',
    'Mag',
    'Giu',
    'Lug',
    'Ago',
    'Set',
    'Ott',
    'Nov',
    'Dic'
  ];
  let html = `<div class="heatmap">
    <div></div>
    ${headMonths.map((m) => `<div class="heatmap-head">${m}</div>`).join('')}`;
  data.forEach((row) => {
    html += `<div class="heatmap-row-label">${row.year}</div>`;
    row.months.forEach((m, idx) => {
      const lvl = heatmapLevel(m.count, max);
      const title = m.count
        ? `${m.count} contratti in scadenza:\n${m.clienti.slice(0, 8).join('\n')}${m.clienti.length > 8 ? '\n…' : ''}`
        : 'Nessun contratto in scadenza';
      html += `<div class="heatmap-cell lvl-${lvl}" data-count="${m.count}" data-year="${row.year}" data-month="${idx}" title="${escapeHtml(title)}">${m.count || ''}</div>`;
    });
  });
  html += '</div>';
  // Total e legenda compatta
  const total = allCounts.reduce((a, b) => a + b, 0);
  html += `<div class="muted" style="margin-top:8px;font-size:11px;display:flex;justify-content:space-between;">
    <span>${total} contratti in scadenza nei prossimi 24 mesi</span>
    <span style="display:inline-flex;gap:4px;align-items:center;">
      meno <span class="heatmap-cell lvl-1" style="width:14px;height:14px;display:inline-grid;"></span>
      <span class="heatmap-cell lvl-2" style="width:14px;height:14px;display:inline-grid;"></span>
      <span class="heatmap-cell lvl-3" style="width:14px;height:14px;display:inline-grid;"></span>
      <span class="heatmap-cell lvl-4" style="width:14px;height:14px;display:inline-grid;"></span> più
    </span>
  </div>`;
  container.innerHTML = html;

  // Click → vista scadenze. Filtri precisi non disponibili (no filterMese),
  // ma cambiamo periodo a 90/365 in funzione del mese target.
  container.querySelectorAll('.heatmap-cell[data-count]').forEach((cell) => {
    const c = parseInt(cell.dataset.count || '0', 10);
    if (!c) return;
    cell.style.cursor = 'pointer';
    cell.addEventListener('click', () => {
      // @ts-ignore — setView globale
      if (typeof setView === 'function') setView('scadenze');
    });
  });
}

// @ts-ignore — global
Object.assign(globalThis, { renderHeatmap, buildHeatmapData });
export {};
